import { useState } from "react";
import ReactQRCode from "react-qr-code"
import { Toast } from "react-bootstrap";

import styles from "./SignupCodePage.module.css"

export default function QRCode({ url }: { url: string })  {
  const [show, setShow] = useState(false);
  const copyJoinUrl = () => {
    navigator.clipboard.writeText(url)
    setShow(true)
  }
  const handleClose = () => setShow(false)

  return (
    <>
      <ReactQRCode value={url} />
      <p>
        {url}
      </p>
      <p>
        <button className="button text inherit" onClick={copyJoinUrl}>Copy Link</button>
      </p>
      <Toast onClose={handleClose} show={show} className={styles.copyToast} delay={3000} autohide>
        <Toast.Body>
          Link Copied
        </Toast.Body>
      </Toast>
    </>
  )
}
